import "./Footer.scss";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { FCCC } from "types";

import { Claim } from "@/components/Layout/Claim/Claim";
import { getCurrentVersion } from "@/utils/versionCheck";

import { CollapsibleLanguageMenu } from "./CollapsibleLanguageMenu";
import { CollapsibleLinkMenu } from "./CollapsibleLinkMenu";
import { SupportLinkItem } from "./SupportLinkItem";

export const Footer: FCCC = ({ className }) => {
  const { t } = useTranslation();
  const version = getCurrentVersion();

  return (
    <footer
      id="footer-wrapper"
      data-testid="footer"
      className={clsx(
        "relative flex min-h-[128px] flex-col pt-[57px] md:flex-row-reverse md:justify-between",
        className,
      )}
    >
      <div className="mb-6 ml-6 flex flex-col items-start gap-4 md:m-0 md:mr-6 md:flex-row md:items-center xl:mr-[112px]">
        <CollapsibleLanguageMenu />
        <SupportLinkItem />
        <CollapsibleLinkMenu />
      </div>
      <div className="my-auto ml-2 flex flex-col justify-between gap-2 md:mb-2 md:ml-2 xl:mb-4 xl:ml-10">
        <Claim />
        <div className="text-xs text-white text-opacity-75">
          {t("Footer.version")} {version}
        </div>
      </div>
    </footer>
  );
};
